import { useEffect, useState, useRef, useCallback } from "react";
import Layout from "./Shared/Layout";
import { FaChevronDown } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { productReorder } from "../redux/action";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { API_URL } from "../_services/apiUrl";
import { get } from "../_services/apiService";
import { decryptData } from "../_services/encDnc";
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ViewOrderDetail from "./Shared/ViewOrderDetail";
import Invoice from "./Shared/Invoice";
import TrackOrder from "./Shared/TrackOrder";

const imageurl = process.env.REACT_APP_IMAGE_BASE_URL

const YourOrder = () => {
    const loginId = localStorage.getItem("loginId");
    const dispatch = useDispatch();
    const [orderData, setOrderData] = useState([]);
    const [customOrderData, setCustomOrderData] = useState([]);
    const navigate = useNavigate();
    const [getTracking, setGetTracking] = useState();
    const [downloadInvoice, setDownloadInvoice] = useState(false);
    const [downloadInvoiceId, setDownloadInvoiceId] = useState(false);
    const [orderNo, setOrderNo] = useState();
    const [activeButton, setActiveButton] = useState('success/pending');
    const [userAddress, setUserAdderss] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const pdfRef = useRef();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showTrackOrder, setShowTrackOrder] = useState(false);

    const handleCloseTrackOrder = () => setShowTrackOrder(false);
    const handleShowTrackOrder = () => setShowTrackOrder(true);

    const generatePdf = async () => {
        const element = pdfRef.current;
        const canvas = await html2canvas(element, {
            scale: 2,
        });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("download.pdf");

        setDownloadInvoice(false);
    };

    const prepareBuyFormData = (items) => {
        return items.map(item => ({
            skuId: item?.skuId || 0,
            cartItemId: 0,
            productId: item.productId,
            loginId: Number(loginId),
            buyStatus: 1,
            quantity: item.quantity,
            unitPrice: item.unitPrice,
            totalAmount: item.unitPrice,
            isActive: true,
            createdBy: 0,
        }));
    };

    const [productOrderData, setProductOrderData] = useState();

    const onInvoiceDownload = useCallback(() => {
        setDownloadInvoice(prevState => !prevState);
    }, []);

    const GetProductOrderByOrderId = useCallback(async (item) => {
        if (!item || !item.orderId) {
            return;
        }

        setDownloadInvoiceId(item.orderId);

        onInvoiceDownload(item.orderId);

        try {
            const response = await get(API_URL.GetProductOrderByOrderId, {
                pProductOrderId: item.orderId,
            });
            if (response.isSuccess === 200) {
                setProductOrderData(response.data[0]);
            } else {
                setProductOrderData([]);
            }
        } catch (error) {
            setProductOrderData([]);
        }
    }, [onInvoiceDownload]);

    useEffect(() => {
        GetProductOrderByOrderId();
    }, [GetProductOrderByOrderId]);

    const fetchProductOrderByLoginId = useCallback(async () => {

        try {
            const response = await get(API_URL.GetProductOrderByLoginId + `?pLoginId=${loginId}`);
            if (response.isSuccess === 200 && response.data != null && response.data.length > 0) {
                const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setOrderData(sortedData);
            } else {
                setOrderData([]);
            }
        } catch (error) {
            setOrderData([]);
        }
    }, [loginId]);

    const getUserAddressByLoginId = useCallback(async () => {
        if (loginId) {
            try {
                const response = await get(`${API_URL?.GetUserAddressByLoginId}?pLoginId=${loginId}`);
                const encryptedData = response.data;
                const result = decryptData(encryptedData);
                if (response.isSuccess === 200) {
                    setUserAdderss(result);
                } else {
                    throw new Error("Failed to fetch product Category data.");
                }
            } catch (error) {
                toast.error(error.response?.data?.message || "Please try again later.");
            }
        }
    }, [loginId]);

    const onTrackOrder = useCallback(async (item) => {
        handleShowTrackOrder();
        try {
            const response = await get(API_URL?.GetShipTracking + `?pOrderId=${loginId}`);
            if (response.isSuccess === 200 && response.data.length > 0 && response.data != null) {
                setGetTracking(response.data);
                setOrderNo(item?.orderNo)
            } else {
                throw new Error("Failed to fetch product Category data.");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Please try again later.");
        }
    }, [loginId]);

    const fetchCustomOrderByLoginId = useCallback(async () => {
        try {
            const response = await get(API_URL.GetCustomOrderByLoginId + `?pLoginId=${loginId}`);
            if (response.isSuccess === 1 && response.data.length > 0 && response.data != null) {
                setCustomOrderData(response.data);
            } else {
                setCustomOrderData([]);
            }
        } catch (error) {
            setCustomOrderData([]);
        }
    }, [loginId]);

    useEffect(() => {
        fetchCustomOrderByLoginId();
        fetchProductOrderByLoginId();
        getUserAddressByLoginId();
    }, [getUserAddressByLoginId, fetchProductOrderByLoginId, fetchCustomOrderByLoginId]);

    const onProductDetail = (item) => {
        if (!item) {
            return;
        }

        localStorage.removeItem('sizeTypeName');
        localStorage.removeItem('colorTypeName');
        localStorage.removeItem('skuId');
        localStorage.removeItem('colorId');

        localStorage.setItem('productId', item?.productId);
        localStorage.setItem('productCategoryId', item?.productCategoryId);
        localStorage.setItem('productSubCategoryId', item?.productSubCategoryId);

        const categoryName = item?.categoryName?.replace(/\s+/g, '_') || '';
        const subCategoryName = item?.productSubCategoryName?.replace(/\s+/g, '_') || '';
        const productName = item?.productName?.replace(/\s+/g, '_') || '';

        navigate(`/${categoryName}/${subCategoryName}/${productName}/${item?.productId}`);
    }

    const Reorder = async (items) => {
        if (!loginId) {
            navigate(`/login`);
            return;
        }

        // Prepare form data
        const formData = prepareBuyFormData(items);

        try {
            await dispatch(productReorder(formData));
            if (userAddress && userAddress.length > 0) {
                localStorage.setItem('selectedAddressId', userAddress[0].addressId);
                navigate("/checkout");
            } else {
                navigate("/shipping-address");
            }
        } catch (error) {
            toast.error("An error occurred while reordering. Please try again.");
        } finally {
            localStorage.removeItem('itemDetail');
        }
    };

    const handleButtonClick = (status) => {
        setActiveButton(status);
        setCurrentPage(1);
    };

    // Filter orders based on the active button
    const filteredOrders = orderData.filter(item => {
        if (activeButton === 'success/pending') {
            return (item.orderStatusId === 1 && item?.actionType !== 'Cancel') ||
                (item.orderStatusId === 3 && item?.actionType !== 'Cancel') ||
                (item.orderStatusId === 5 && item?.actionType !== 'Cancel');
        } else if (activeButton === 'failed') {
            return item.orderStatusId === 4 && item.cancelStatus === "N";
        } else if (activeButton === 'cancle') {
            return item?.cancelStatus === "Y" && item?.actionType === 'Cancel';
        }
        return true;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentOrders = filteredOrders.slice(indexOfFirstItem, indexOfLastItem).reverse();

    const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const onCancelOrder = (item) => {
        const order = `${item?.deliveryStatus === 'Y' ? 'return' : 'cancel'}`;
        sessionStorage.setItem('actionType', order);
        navigate(`/cancel-order/${item?.orderId}`);
    };

    return (
        <Layout>
            <Invoice
                pdfRef={pdfRef}
                productOrderData={productOrderData}
                currentOrders={currentOrders}
            />
            <section className="product_wepper_main layout_main">
                <div className="container col-xl-8 col-12">
                    <div className="my_order_heading">
                        <h1>YOUR ORDERS</h1>
                    </div>
                    <div className="filter_status_button mt-3">
                        <button
                            className={`status_filter ${activeButton === 'success/pending' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('success/pending')}
                        >
                            Success/Pending
                        </button>
                        <button
                            className={`status_filter ${activeButton === 'failed' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('failed')}
                        >
                            Failed
                        </button>
                        <button
                            className={`status_filter ${activeButton === 'cancle' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('cancle')}
                        >
                            Cancel Order
                        </button>
                        <button
                            className={`status_filter ${activeButton === 'custom' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('custom')}
                        >
                            Custom Order
                        </button>
                    </div>

                    {activeButton !== 'custom' && (
                        <>
                            <div className="my_order_list mt-4">
                                {currentOrders?.length > 0 ? (
                                    currentOrders?.map((item, i) => (
                                        <div className="order_box mb-4" key={i}>
                                            <div className="product_order_details d-md-flex justify-content-between">
                                                <div className="head_first_div d-sm-flex justify-content-sm-between">
                                                    <div className="d-flex justify-content-between mb-sm-auto mb-3">
                                                        <div className="order_id">
                                                            <p className="heading mb-0">Order placed</p>
                                                            <p className="description_detail mb-0">
                                                                {item?.orderDate
                                                                    ? new Date(item?.orderDate).toLocaleDateString('en-GB', {
                                                                        day: 'numeric',
                                                                        month: 'long',
                                                                        year: 'numeric'
                                                                    })
                                                                    : null}
                                                            </p>
                                                        </div>
                                                        <div className="total_order_amount">
                                                            <p className="total_title mb-0">Total</p>
                                                            <p className="total_amount mb-0"> ₹{item?.totalAmount}</p>
                                                        </div>
                                                    </div>
                                                    <div className="order_id ship_to_address_hover">
                                                        <p className="heading mb-0">Ship to</p>
                                                        <div className="ship_to_button">
                                                            <button className="description_detail mb-0">{item?.name} <FaChevronDown /></button>
                                                            <div className="shipping_address arrow-top">
                                                                <div className="shipping_address_detail">
                                                                    <p className="user_name mb-0">{item?.name}</p>
                                                                    <p>{item?.shippingAddress}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="head_first_div mt-md-auto mt-3">
                                                    <div className="order_id d-flex align-items-center justify-content-end" style={{ gap: '8px' }}>
                                                        <p className="heading mb-0">orderNo :</p>
                                                        <p className="description_detail mb-0">{item?.orderNo}</p>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-end">
                                                        <div className="view_detail_button">
                                                            <Button type="button" className="view_orderdetail_btn" variant="" onClick={handleShow}>
                                                                View order details
                                                            </Button>

                                                            <Modal show={show} onHide={handleClose} centered>
                                                                <Modal.Header closeButton>
                                                                    <Modal.Title>Order Details</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>
                                                                    <ViewOrderDetail
                                                                        item={item}
                                                                    />
                                                                </Modal.Body>
                                                            </Modal>
                                                        </div>
                                                        <div className="between_sapration"></div>
                                                        <div className="invoice">
                                                            <button title="Download Invoice" className="invoice_button mb-0" onClick={() => GetProductOrderByOrderId(item)}>Invoice <FaChevronDown /></button>
                                                            {downloadInvoiceId === item.orderId ?
                                                                downloadInvoice && (
                                                                    <div id="invoiceContent" className="invoiceContent">
                                                                        <button onClick={generatePdf} className="download_invoice">
                                                                            Download
                                                                        </button>
                                                                    </div>
                                                                ) : null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {item?.orderItemDtos?.length > 0 ? (
                                                <div className="product_order_data_wrapper d-sm-flex ">
                                                    <div className="col-sm-9 col-12">
                                                        {item.orderItemDtos.map((element, j) => (
                                                            <div className="product_order_content row p-3" key={j}>
                                                                {element?.productImageDtos?.length > 0 ? (
                                                                    // Check if there's any image with isHeader
                                                                    element.productImageDtos.some(image => image.isHeader) ? (
                                                                        element.productImageDtos.map((image, k) => (
                                                                            image.isHeader ? (
                                                                                <div key={`${k}-${j}`} className="product_order__image col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-3 col-12" onClick={() => onProductDetail(element)}>
                                                                                    <img
                                                                                        className="curser-pointer w-100"
                                                                                        src={`${imageurl}${image?.imgPath}`}
                                                                                        alt="Product"
                                                                                    />
                                                                                </div>
                                                                            ) : null
                                                                        ))
                                                                    ) : (
                                                                        // If no isHeader image, fall back to the first image in the list
                                                                        <div key={`${j}-0`} className="product_order__image col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-3 col-12" onClick={() => onProductDetail(element)}>
                                                                            <img
                                                                                className="curser-pointer w-100"
                                                                                src={element.productImageDtos[0]?.imgPath ? `${imageurl}${element.productImageDtos[0]?.imgPath}` : './images/defaultImage.png'}
                                                                                alt="Product"
                                                                            />
                                                                        </div>
                                                                    )
                                                                ) : (
                                                                    // If no images at all, show default image
                                                                    <div key={`${j}-default`} className="product_order__image col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-3 col-12" onClick={() => onProductDetail(element)}>
                                                                        <img
                                                                            className="curser-pointer w-100"
                                                                            src="./images/defaultImage.png"
                                                                            alt="Product"
                                                                        />
                                                                    </div>
                                                                )}


                                                                <div className="product_order_name col-xxl-9 col-xl-9 col-lg-9 col-md-8 col-sm-9 col-12">
                                                                    <h5 className="product_name" onClick={() => onProductDetail(element)}>{element?.productName}</h5>
                                                                    <div>
                                                                        <div className="d-flex" style={{ gap: '5px' }}>
                                                                            <p className="mb-1" style={{ color: '#8e183c' }}>Quantity : </p>
                                                                            <p className="mb-1" style={{ color: '#8e183c' }}>{element?.quantity}</p>
                                                                        </div>
                                                                        <p style={{ color: '#8e183c', fontWeight: '500' }}>₹{element?.unitPrice}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="order_btn_wrapper col-sm-3 col-12 pt-sm-3">
                                                        {(item?.isShipStatus === "Y" && item?.cancelStatus === "N" && item?.deliveryStatus !== 'Y') &&
                                                            <>
                                                                <button onClick={() => onTrackOrder(item)} className="track_order_btn web_buttons" title="click" type="button">Track Order</button>
                                                                <Modal show={showTrackOrder} onHide={handleCloseTrackOrder} centered>
                                                                    <Modal.Header closeButton>
                                                                        <Modal.Title>Order Details</Modal.Title>
                                                                    </Modal.Header>
                                                                    <Modal.Body>
                                                                        <TrackOrder
                                                                            getTracking={getTracking}
                                                                            orderNo={orderNo}
                                                                        />
                                                                    </Modal.Body>
                                                                </Modal>
                                                            </>
                                                        }
                                                        <div className="bttn_wepper2" >
                                                            <button className='buy_it_order_btn web_buttons' onClick={() => Reorder(item.orderItemDtos)}>
                                                                Reorder
                                                            </button>
                                                        </div>

                                                        {(item?.cancelStatus === "N" && item.orderStatusId !== 4) &&
                                                            <div className="bttn_wepper2" >
                                                                <button className='buy_it_order_btn web_buttons' onClick={() => onCancelOrder(item)}>
                                                                    {item?.deliveryStatus === 'Y' ? 'Return/Exchange' : 'Cancel Order'}
                                                                </button>
                                                            </div>
                                                        }

                                                        {(item?.cancelStatus === "Y") &&
                                                            <div className="bttn_wepper2" >
                                                                <button className='buy_it_order_btn web_buttons' disabled>
                                                                    Cancelled
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    ))
                                ) :
                                    <div>
                                        <p className="no_data_message">No orders available at the moment.</p>
                                    </div>
                                }
                            </div>
                            {currentOrders?.length > 0 ? (
                                <div className="pagination">
                                    <div className="pagination_box">
                                        {[...Array(totalPages).keys()].map(pageNumber => (
                                            <button
                                                key={pageNumber}
                                                onClick={() => handlePageChange(pageNumber + 1)}
                                                className={currentPage === pageNumber + 1 ? 'active' : ''}
                                            >
                                                {pageNumber + 1}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </>
                    )}

                    {activeButton === 'custom' && customOrderData?.length > 0 && (
                        <div className="my-4">
                            {/* <h2>Custom Order Details</h2> */}
                            <div className="order-details row">
                                {customOrderData?.map((item, i) => {
                                    return (
                                        <div className="custom_order_detail_main order-details-custom col-lg-6 col-12 mb-3" key={i}>
                                            <div className="custom_order_detail">
                                                <div className="row">
                                                    <div>
                                                        <h6 className="order_count">{i + 1}</h6>
                                                    </div>
                                                    <div className="custom_order_detail_content col-12">
                                                        <h6>Product Name :</h6>
                                                        <span>{item?.productName}</span>
                                                    </div>
                                                    <div className="custom_order_detail_content col-sm-6 col-12">
                                                        <h6>Breast Size :</h6>
                                                        <span>{item?.breastSize}</span>
                                                    </div>
                                                    <div className="custom_order_detail_content col-sm-6 col-12">
                                                        <h6>Weist Size :</h6>
                                                        <span>{item?.weistSize}</span>
                                                    </div>
                                                    <div className="custom_order_detail_content col-sm-6 col-12">
                                                        <h6>Hip Size :</h6>
                                                        <span>{item?.hipSize}</span>
                                                    </div>
                                                    <div className="custom_order_detail_content col-sm-6 col-12">
                                                        <h6>Shoulder :</h6>
                                                        <span>{item?.shoulder}</span>
                                                    </div>
                                                    <div className="custom_order_detail_content col-sm-6 col-12">
                                                        <h6>Armhole :</h6>
                                                        <span>{item?.armhole}</span>
                                                    </div>
                                                    <div className="custom_order_detail_content col-sm-6 col-12">
                                                        <h6>Quantity :</h6>
                                                        <span>{item?.quantity}</span>
                                                    </div>
                                                    <div className="custom_order_detail_content col-sm-6 col-12">
                                                        <h6>Message :</h6>
                                                        <span>{item?.remark}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                </div>
            </section>
        </Layout>
    )
}

export default YourOrder;